import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const ButtonWrapper = styled.div`
  padding: ${rem(16)} ${rem(18)};
  ${({ theme }) => theme.media.fold`
      padding: ${rem(14)} ${rem(20)};
    `}
`;
